import { Button } from "./ui/button";
import { FolderOpen, Phone } from "lucide-react";

export function Header({ onLoadQuote, onRequestCallback, embedded = false }) {
  // Hide header completely when embedded in another site
  if (embedded) return null;
  
  return (
    <>
      {/* Top Banner */}
      <div className="bg-[#6A7359] text-white text-center py-1 text-sm hidden sm:block font-sans">
        <span className="font-medium tracking-wide">MADE IN CANADA</span>
        <span className="mx-4">|</span>
        <span className="tracking-wide">READY IN 2 WEEKS</span>
      </div>
      
      {/* Main Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-3 py-2 sm:px-4 sm:py-3">
          <div className="flex justify-between items-center">
            <img 
              src="https://readytopaintcabinetdoors.com/cdn/shop/files/Ready_To_Paint_Cabinet_Door_logo_Ontario_Made2_500x.png?v=1741307062" 
              alt="Ready To Paint Cabinet Doors Logo" 
              className="h-10 sm:h-14" 
            />
            <div className="flex items-center gap-1 sm:gap-3">
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={onLoadQuote} 
                className="text-[#6A7359] hover:bg-gray-100 px-2 sm:px-3 font-sans" 
                data-testid="load-quote-btn"
              >
                <FolderOpen className="w-4 h-4 sm:mr-1" />
                <span className="hidden sm:inline">Load Quote</span>
              </Button>
              <Button 
                size="sm" 
                onClick={onRequestCallback} 
                className="bg-[#6A7359] hover:bg-[#565E48] text-white px-2 sm:px-3 font-sans" 
                data-testid="callback-btn"
              >
                <Phone className="w-4 h-4 sm:mr-1" />
                <span className="hidden sm:inline">Request Callback</span>
              </Button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
